import { Search } from '../../../types'
import { ActionStepSchema } from '@feedyou/schema'

import { createConfigs, searchMutableObject } from '../../../../../features/flowSearch'

export const search: Search<ActionStepSchema> = (step, query) => {
  return searchMutableObject(
    step,
    query,
    { type: 'step', id: step.id },
    createConfigs({
      id: ['id'],
      text: ['condition']
    })
  )
}
